import { useEffect } from 'react';

import { supabaseClient } from '@auth-v2';

import { subscribeToSwingThreads } from '@data';
import { queryClient, getSwingThreadsKey } from '@queries';

export const useSwingThreadSubscription = (swingUuid: string) => {
    useEffect(() => {
        const sub = subscribeToSwingThreads(supabaseClient, swingUuid, () => {
            queryClient.invalidateQueries({
                queryKey: getSwingThreadsKey(swingUuid),
            });
        });

        return () => {
            sub.unsubscribe();
        };
    }, [supabaseClient, swingUuid]);
};
